import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Form from '../../../components/PaymentForm/Form'
import http from '../../../config/BaseUrl'
import LocalStorage from "../../../hook/LocalStorage";
import { useForm } from "react-hook-form";
import amx from '../../../assets/images/payment/amx.png'
import masterCard from '../../../assets/images/payment/mastercard.png'
import visa from '../../../assets/images/payment/visa.png'
import Logo from '../../../assets/images/logo/Haylo-logo-white.png'

function PaymentPage() {

  const { access_token, user } = LocalStorage();
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const packageData = history.location.state.package

  const { register, handleSubmit, formState: { errors }, setError, watch, setValue } = useForm({ mode: "all", reValidateMode: "all" })

  const handleSubmitForm = async (data) => {
    const formData = {
      cardNumber: data.cardNumber,
      cardholderName: data.cardholderName,
      cvvNumber: data.cvvNumber,
      expiryMonth: data.expiryMonth,
      expiryYear: data.expiryYear,
      user_id: user.id,
      user_email: user.email,
      submittedData: packageData,
      // auto_renewal: data.auto_renewal
    }
    const configToken = {
      headers: { Authorization: `Bearer ${access_token}` }
    };
    try {

      setLoading(true)
      await http.post("member-ship", formData, configToken).then((res) => {
        if (res.data.card_info) {
          setLoading(false)
          localStorage.setItem("users", JSON.stringify(res.data.user))
          history.push('/event/payment-success')
        } else {
          history.goBack()
        }
      })


    } catch (error) {
      console.log(error.message);
    }

  }

  return (
    <div className="p-3 section-authentication-login p-md-0">
      <div className="px-0 container-fluid">

        <div className="row h-100">
          <div className="col-md-6 d-none d-md-block">
            <div className="page-image">
              <div className="mt-5 login-header">
                <div className="logo">
                  <img src={Logo} className="img-fluid" alt="haylo" />
                </div>
              </div>
              <div className="image-body">
              </div>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <div className="form-body">
              <div className="row justify-content-center align-items-center h-100">
                <div className="col-md-10 col-lg-10 col-xl-7 col-sm-9 col-12">
                  <div className="payment-form">
                    <div className="payment-form-body">
                      <form onSubmit={handleSubmit(handleSubmitForm)}>
                        <div className="mb-3 payment-summery border-bottom">
                          <div className="payment-summery-heading">
                            <p className="font-weight-bold text-secondary">Summary</p>
                          </div>
                          <div className="pb-2 payment-information d-flex align-items-center justify-content-between">
                            <div className="package-name">
                              <h5>{packageData.package_name} <span className="text-capitalize">({packageData.billed})</span></h5>
                            </div>
                            <div className="package-pricing">
                              <h5>$ {packageData.price}/<span>{packageData.billed === "yearly" ? "yr" : "mo"}</span></h5>
                            </div>
                          </div>
                        </div>
                        <div className="pb-3 text-center form-header border-bottom payment-form-header">
                          <h4 className="mb-0 text-secondary text-uppercase">Card Information</h4>
                          <div className="payment-images">
                            <div className="card-item">
                              <img src={visa} className="img-fluid" alt="visa" />
                            </div>
                            <div className="card-item">
                              <img src={masterCard} className="img-fluid" alt="masterCard" />
                            </div>
                            <div className="card-item">
                              <img src={amx} className="img-fluid" alt="amx" />
                            </div>
                          </div>
                        </div>
                        <Form register={register} errors={errors} watch={watch} setValue={setValue} />
                        {/* <div className="form-group form-check">
                          <input type="checkbox" className="form-check-input" id="exampleCheck1" {...register('auto_renewal')} />
                          <label className="form-check-label" for="exampleCheck1">Auto Renewal</label>
                        </div> */}
                        <div id="addExistBtn">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                          >
                            {loading && loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
                              : ("Subscribe")
                            }
                          </button>
                        </div>
                      </form>
                    </div>

                    <div className="payment-page-footer">
                      <p onClick={() => history.goBack()} className="text-primary" style={{ cursor: 'pointer' }}>Back To Previous Page</p>
                    </div>

                  </div>



                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>
  )
}

export default PaymentPage
